import * as turf from '@turf/turf'

export const requestPois = (aLonLat, areas) => {
  const pos = turf.point(aLonLat)
  let req = true
  for (let area of areas) {
    if (turf.booleanPointInPolygon(pos, area)) {
      req = false
      break
    }
  }
  return req
}

export const pageImage = page => {
  const thumb = page.thumbnail ? page.thumbnail.source : null
  const image = page.pageimage
  if (thumb && image) {
    const ext = image.split('.').pop()
    let path = thumb.split(ext)[0]
    path = path.replace('/thumb', '')
    path += ext
    return path
  } else {
    return null
  }
}

export const pointsToConcav = aPoints => {
  const points = turf.featureCollection(aPoints.map(p => turf.point(p)))
  return turf.concave(points)
}
